import Button from "../../../../ui/molecules/button";
import { Spinner } from "../../../../ui/molecules/spinner";
import { PersonDTO } from "../../../database/people/dto";
import { ContactStateEnum } from "../../dto";

interface Props {
    onClose: () => void;
    listIndex: number;
    isLoading: boolean
    handleConfirm: (outcome: ContactStateEnum, outcomeInfo: string | null) => void;
    person: PersonDTO;
}

export function LeadTakenPrivacyVerified({ onClose, listIndex, isLoading, handleConfirm, person }: Props) {
    const fullName = ` ${person.name} ${person.surname} `;
    return (
        <>
            <p className="text-text-md font-medium text-neutral-600 text-center max-w-lg">
                Hai già verificato il consenso alla Privacy per
                <span className="font-bold text-neutral-800">
                    {fullName}
                </span>
                al numero di telefono
                <span className="font-bold text-neutral-800">
                    { } {person.phone}
                </span>.
                <br />
                <br />

                Clicca su "<span className="font-bold text-neutral-800">Conferma</span>" per prendere il lead in carico.
            </p>
            <div className="flex w-3/4 items-center gap-4">
                <div className="flex-1">
                    <Button size={"sm"} iconPosition={"left"} variant={"outline"} color={"gray"} label="Annulla" onClick={() => onClose()} fullWidth />
                </div>
                {
                    isLoading ?
                        <div className="flex-1 flex items-center justify-center">
                            <Spinner color="green" size={32} />
                        </div> :
                        <div className="flex-1">
                            <Button size={"sm"} iconPosition={"left"} variant={"solid"} color={"green"} label="Conferma" fullWidth
                                onClick={() => handleConfirm(ContactStateEnum.LEADTAKEN, null)}
                            />
                        </div>
                }
            </div>
        </>
    )
}